import { useQuery } from '@tanstack/react-query';

import type { AgentApiCandidateMailSettingsShow } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchCandidateMailSetting({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['candidateMailSetting'],
    queryFn: () =>
      fetchJson<AgentApiCandidateMailSettingsShow>('/agent/api/candidate_mail_setting'),
    enabled,
  });
}
